import { CSSObject } from "@emotion/react";
import {
  constants,
  mediaQueryStyles,
  typographyStyles,
} from "@newsela/angelou";

const { mediaQuery } = mediaQueryStyles;
const { heading4Obj, heading5Obj } = typographyStyles;

export const bundleRowContainerCss: CSSObject = {
  padding: "1rem",
  borderRadius: "1rem",
  background: constants.colors.ui.neutral[25],
  marginBottom: "1.5rem",
  "&:first-of-type": {
    marginTop: "1.5rem",
  },
  "&:last-of-type": {
    marginBottom: 0,
  },
  display: "grid",
  gridTemplateColumns: "1rem 1fr 1rem",
  gridTemplateRows: "auto auto 1fr",
  [mediaQuery.downTo(constants.breakpoints.Breakpoints.xs)]: {
    padding: "1.5rem",
  },
};

export const defaultHeadingCss: CSSObject = {
  ...heading4Obj,
  fontWeight: 700,
  color: constants.colors.ui.neutral[700],
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
};

export const headerDescriptionCss: CSSObject = {
  ...typographyStyles.fontFamily.circular,
  ...heading5Obj,
  lineHeight: "137.5%",
  color: constants.colors.ui.neutral[600],
};

export const headerIconCss: CSSObject = {
  marginRight: "5px",
  width: "24px",
  height: "24px",
};

export const headerAndDescriptionContainerCss: CSSObject = {
  gridColumn: "1 / -1",
  gridRow: "1 / 3",
  display: "flex",
  flexDirection: "column",
  gap: "0.5rem",
  marginBottom: "0.25rem",
};

export const linkCss = {
  root: {
    color: constants.colors.ui.core[700],
  },
};

export const contentScrollableListCss: CSSObject = {
  display: "flex",
  gap: 12,
  padding: 0,
  margin: 0,
  listStyle: "none",
  alignItems: "stretch",
};

export const listItemCss: CSSObject = {
  flex: "0 0 clamp(240px, 28vw, 320px)",
  "& > *": {
    height: "100%",
    display: "grid",
  },
};
